angular.module('zc.projects')
  .controller('CampaignBulkEditModalController', CampaignBulkEditModalController);

CampaignBulkEditModalController.$inject = ['$filter', '$modalInstance', '$q', '$state', '$window', 'Campaign', 'campaigns', 'incentives', 'project'];
function CampaignBulkEditModalController($filter, $modalInstance, $q, $state, $window, Campaign, campaigns, incentives, project) {
  const vm = this;

  vm.campaigns = campaigns;
  vm.incentives = incentives;
  vm.project = project;
  vm.selectedIncentive = null;
  vm.selectedIncentives = [];
  vm.addIncentive = addIncentive;
  vm.removeIncentive = removeIncentive;
  vm.cancel = cancel;
  vm.save = save;
  vm.isValid = isValid;
  vm.enoughInput = enoughInput;
  vm.isSaving = false;
  vm.incentiveRegistrationUrl = $state.href('admin.projects.incentives', { projectId: vm.project.id }, { absolute: true });
  vm.region = project.region;
  vm.gmtOffset = '(' + moment().tz(vm.region).format('Z') + ')';
  vm.endDate = null;
  vm.endTime = null;

  sortIncentives();

  _.forEach(vm.incentives, incentive => {
    if(incentive.incentive_type === 'api_url') {
      incentive.example = ` [${incentive.api_url}]`;
    } else if(incentive.incentive_type === 'coupon_url') {
      incentive.example = ` [${incentive.pc_base_url}]`;
    } else {
      incentive.example = ` [${incentive.coupon_code}]`;
    }
  });

  function addIncentive(selectedIncentive) {
    vm.selectedIncentive = null;
    vm.selectedIncentives.push(selectedIncentive);
    vm.incentives = _.reject(vm.incentives, incentive => incentive.id === selectedIncentive.id);
    sortSelectedIncentives();
  }

  function removeIncentive(incentive) {
    vm.selectedIncentives = _.reject(vm.selectedIncentives, selectedIncentive => selectedIncentive.id === incentive.id);
    vm.incentives.push(incentive);
    sortIncentives();
  }

  function cancel() {
    $modalInstance.close();
  }

  function save() {
    if(vm.isSaving) return;
    vm.isSaving = true;
    let incentivePromises = [];
    if(vm.selectedIncentives.length > 0) {
      const incentiveIds = _.map(vm.selectedIncentives, 'id');
      incentivePromises = _.map(vm.campaigns, campaign =>
        Campaign.addIncentives({
          project_id: vm.project.id,
          campaign_id: campaign.id,
          incentive_ids: incentiveIds,
        })
      );
    }

    let datePromises = [];
    if(vm.endDate && vm.endTime) {
      datePromises = _.map(vm.campaigns, campaign => {
        const updatedCampaign = _.cloneDeep(campaign);
        updatedCampaign.end_at = moment(`${vm.endDate} ${vm.endTime}`, 'YYYY/MM/DD hh:mm').toDate();
        updatedCampaign.end_at_obj = $filter('dateToDateObj')(updatedCampaign.end_at);
        updatedCampaign.is_infinite = false;
        return Campaign.update({
          projectId: vm.project.id,
          campaignId: campaign.id,
        }, updatedCampaign);
      });
    }

    $q.all([...incentivePromises, ...datePromises]).then(() => $window.location.reload());
  }

  function sortIncentives() {
    vm.incentives = _.sortBy(vm.incentives, incentive => -new Date(incentive.updated_at).valueOf());
  }

  function sortSelectedIncentives() {
    vm.selectedIncentives = _.sortBy(vm.selectedIncentives, selectedIncentive => -new Date(selectedIncentive.updated_at).valueOf());
  }

  function isValid() {
    const allRequiresIncentives = _.every(vm.campaigns, campaign => campaign.requires_incentives);
    if(!allRequiresIncentives && vm.selectedIncentives.length) return false;
    return true;
  }

  function enoughInput() {
    const dateOnly = vm.selectedIncentives.length === 0 && vm.endDate && vm.endTime;
    const incentiveOnly = vm.selectedIncentives.length && !vm.endDate && !vm.endTime;
    const bothChange = vm.selectedIncentives.length && vm.endDate && vm.endTime;
    if(dateOnly || incentiveOnly || bothChange) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/campaign_bulk_edit_modal.js